function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const LinkIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.8 19.9c-.4 0-.8-.2-1.1-.5-3-3-3-7.8 0-10.8l6-6C20 1.2 22 .4 24 .4s4 .8 5.4 2.2c3 3 3 7.8 0 10.8l-2.7 2.7c-.6.6-1.7.6-2.3 0s-.6-1.7 0-2.3l2.7-2.7c1.7-1.7 1.7-4.5 0-6.2-.8-.8-1.9-1.3-3.1-1.3s-2.3.5-3.1 1.3l-6 6c-1.7 1.7-1.7 4.5 0 6.2.6.6.6 1.7 0 2.3-.3.3-.7.5-1.1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 31.6c-2 0-4-.8-5.4-2.2-3-3-3-7.8 0-10.8l2.7-2.7c.6-.6 1.7-.6 2.3 0s.6 1.7 0 2.3l-2.7 2.7c-1.7 1.7-1.7 4.5 0 6.2.8.8 1.9 1.3 3.1 1.3s2.3-.5 3.1-1.3l6-6c1.7-1.7 1.7-4.5 0-6.2-.6-.6-.6-1.7 0-2.3s1.7-.6 2.3 0c3 3 3 7.8 0 10.8l-6 6C12 30.8 10 31.6 8 31.6z"
  }));
};
export default LinkIcon;